<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <b-table
                striped
                hover
                :items="items"
                :fields="fields"
                show-empty
                :current-page="currentPage"
                :per-page="CONSTANTS.ITEM_PER_PAGE"
            >
                <template #cell(index)="data">{{
                    (currentPage - 1) * CONSTANTS.ITEM_PER_PAGE + (data.index + 1)
                }}</template>
                <template #cell(image)="data">
                    <b-img :src="`${API_CONFIG.URL_GET_FILE}${data.value}`" height="100" />
                </template>
                <template #cell(actions)="row">
                    <b-button
                        variant="danger"
                        @click="confirmDelete(row.item.id)"
                        v-b-tooltip.hover
                        class="min-width-none"
                        :title="$t('common.delete')"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>Không có bản ghi nào</span>
                    </div>
                </template>
            </b-table>
            <div v-if="totalRows > CONSTANTS.ITEM_PER_PAGE" class="my-1">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="CONSTANTS.ITEM_PER_PAGE"
                    :hide-goto-end-buttons="true"
                    :prev-text="$t('common.prevPage')"
                    :next-text="$t('common.nextPage')"
                    class="my-0"
                    align="center"
                />
            </div>
        </div>

        <!-- Confirm Delete -->
        <b-modal
            ref="deleteModal"
            :title="$t('common.confirmation')"
            no-close-on-esc
            no-close-on-backdrop
            :ok-title="$t('common.delete')"
            :cancel-title="$t('common.cancel')"
            ok-variant="danger"
            @ok="onDelete"
            >Bạn có chắc chắn muốn dữ liệu này?</b-modal
        >
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CONSTANTS from '@/constants';
import API_CONFIG from '@/api-config';
export default {
    mounted: function () {
        this.$nextTick(function () {
            this.getList();
            this.totalRows = this.items.length;
        });
    },
    computed: {
        ...mapState({
            items: (state) => state.flood.items
        })
    },
    data() {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                { tdClass: 'align-middle', key: 'image', label: 'Hình ảnh' },
                { tdClass: 'align-middle', key: 'desc', label: 'Mô tả' },
                {
                    tdClass: 'align-middle',
                    key: 'location',
                    label: 'Vị trí'
                },
                {
                    thClass: 'fixed-actions-col',
                    tdClass: 'align-middle',
                    key: 'actions',
                    label: this.$i18n.t('common.actions')
                }
            ],
            currentId: null,
            currentPage: 1,
            CONSTANTS,
            totalRows: 0,
            API_CONFIG
        };
    },
    methods: {
        ...mapActions({
            getList: 'flood/getList',
            deleteById: 'flood/delete'
        }),
        async onDelete(modal) {
            modal.preventDefault();
            await this.deleteById({ id: this.currentId });
            if (this.items.length / this.CONSTANTS.ITEM_PER_PAGE === this.currentPage - 1) {
                this.currentPage--;
            }
            this.$refs.deleteModal.hide();
            this.$toaster.success('Xoá danh mục thành công!');
        },
        async confirmDelete(zoneId) {
            this.currentId = zoneId;
            this.$refs.deleteModal.show();
        }
    }
};
</script>
